import Category from './Models/Category'

Vue.prototype.$models.$category = new Vue(Category)

Vue.component('categories-table', () => import(/* webpackChunkName: "categories-table" */ '@modulesPages/Category/Resources/assets/js/Tables/CategoriesTable'))

Vue.component('categories-form', () => import(/* webpackChunkName: "categories-form" */ '@modulesPages/Category/Resources/assets/js/Forms/Categories/CategoriesForm'))

Vue.component('categories-card', () => import(/* webpackChunkName: "categories-card" */ '@modulesPages/Category/Resources/assets/js/Cards/CategoriesCard'))

Vue.component('categories-tree-button', () => import(/* webpackChunkName: "categories-tree-button" */ '@modulesPages/Category/Resources/assets/js/Components/CategoriesTreeButton'))
Vue.component('resource-categorizable', () => import(/* webpackChunkName: "resource-categorizable" */ '@modulesPages/Category/Resources/assets/js/Components/ResourceCategorizable'))


app.$Util.formattedClassName = {
	...app.$Util.formattedClassName,
	...{
		'Modules\\Category\\Entities\\Category': 'Categoría',
	}	
}

app.$Util.tableNameByClassName = {
	...app.$Util.tableNameByClassName,
	...{
		'Modules\\Category\\Entities\\Category': 'categories',
	}	
}

app.$Util.classNameByTableName = {
	...app.$Util.classNameByTableName,
	...{
		'categories': 'Modules\\Category\\Entities\\Category',
	}	
}




Vue.component('categories-form2', () => import(/* webpackChunkName: "categories-form2" */ '@modulesPages/Category/Resources/assets/js/Forms/Categories/CategoriesForm2'))